module.exports = __webpack_public_path__ + "static/media/shop-primary-header.f11ff1c3.jpg";